import React from "react";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";
import { Card, CardBody } from "reactstrap";

export const ColouredLink = ({ color, hoverColor, onClick, children, className }) => {

  const linkStyle = {
    color: color || "#72B566",
    textDecoration: 'none', 
    transition: 'color 0.2s ease',
    cursor: 'pointer',
  };

  const handleMouseEnter = (e) => {
    e.target.style.color = 'grey' || hoverColor;
  };

  const handleMouseLeave = (e) => {
    e.target.style.color = linkStyle.color;
  };

  const handleClick = () => {
    onClick();
  };

  return (
    <a
      style={linkStyle}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
      className={className || ''}
    >
      {children}
    </a>
  );
};

const SettingItem = ({ to, title, description }) => (
  <div>
    <Link to={to} className="link">
      <Trans>{title}</Trans>
    </Link>
    <br />
    <span className="text-muted">
      <Trans>{description}</Trans>
    </span>
  </div>
);

const HoverCard = ({ imgSrc, to, title, description }) => (
  <Card
    className="d-flex align-items-center justify-flex-start w-100"
    style={{
      transition: 'transform 0.3s',
    }}
    onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
    onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
  >
    <CardBody
      className="d-flex align-items-center justify-space-between w-100"
    >
      <div className="d-flex align-items-center">
        <Link to={to}>
          <img src={imgSrc} alt="user" width="50" />
        </Link>
      </div>
      <div className="ml-2" style={{ width: 'calc(100% - 60px)' }}>
        <SettingItem to={to} title={title} description={description} />
      </div>
    </CardBody>
  </Card>
);

export default HoverCard;
